export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-align-justify-ca4b34292ff42db4ad7205f34385a9bc.svg";